import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Select, Table } from 'tdesign-react';
import { isEmpty, renderDateTime, toTsOptions } from '@/utils/common';
import useTable from '@/hooks/useTable';
import Tip from '@/components/Tip';
import IndividuallyModal from './IndividuallyModal';

const { FormItem } = Form;

export const renderBoolean = ({ row, col }) => {
  const item = row[col.colKey];
  if (isEmpty(item)) {
    return '-';
  }
  return item === true ? '是' : '否';
};

function Cursors({ cursorsList }) {
  const columns = [
    {
      title: '订阅名',
      colKey: 'sub',
      width: 120,
    },
    {
      title: <Tip content='该位置之前的消息都已消费完(markDeletePosition)'>删除标记位置</Tip>,
      colKey: 'markDeletePosition',
      width: 135,
    },
    {
      title: (
        <Tip content='在没有空洞和重试消息都情况下，下一条读取消息位置(readPosition)'>
          最新读取位置
        </Tip>
      ),
      colKey: 'readPosition',
      width: 135,
    },
    {
      title: '空洞消息',
      colKey: 'individuallyDeletedMessages',
      cell: ({ row }) => <IndividuallyModal detail={row} />,
      width: 90,
    },
    // {
    //   title: 'Waiting Read Op',
    //   colKey: 'waitingReadOp',
    //   width: 160,
    //   cell: renderBoolean,
    // },
    // {
    //   title: 'Pending Read Op',
    //   colKey: 'pendingReadOps',
    //   width: 160,
    // },
    // {
    //   title: '状态',
    //   colKey: 'state',
    //   width: 100,
    // },
    {
      title: <Tip content='记录Cursors元数据信息的Ledger'>Ledger最近切换时间</Tip>,

      colKey: 'lastLedgerSwitchTimestamp',
      width: 200,
      cell: renderDateTime,
    },
  ];

  const { header, config, setData, form } = useTable({
    columns,
    refresh: null,
    columnController: null,
    searchButton: null,
    search: (
      <FormItem name='sub'>
        <Select
          clearable
          filterable
          placeholder='请输入订阅名'
          options={toTsOptions(
            cursorsList.map((item) => ({
              label: String(item.sub),
              value: item.sub,
            })),
          )}
        />
      </FormItem>
    ),
  });

  const sub = Form.useWatch('sub', form);

  useEffect(() => {
    if (sub) {
      setData(cursorsList.filter((item) => item.sub === sub));
    } else {
      setData(cursorsList);
    }
  }, [cursorsList, setData, sub]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

export default connect((state) => ({
  cursorsList: state.topic.storage.cursorsList || [],
}))(Cursors);

const Root = styled.div`
  padding-top: 8px;
`;
